import React, { FC } from 'react';

import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MobileSdkTestAllIssues } from './all-issues/MobileSdkTestAllIssues';
import { MobileSdkSessionOverview } from './overview/MobileSdkSessionOverview';
import { MobileSdkTestScans } from './scans';

interface IMobileSdkSingleTestTabContentProps {
	viewId: SessionViews;
	testId: string;
	showScansTab: boolean;
}

export const MobileSdkSingleTestTabContent: FC<IMobileSdkSingleTestTabContentProps> = ({
	viewId,
	testId,
	showScansTab
}) => {
	switch (viewId) {
		case SessionViews.OVERVIEW: {
			return <MobileSdkSessionOverview testId={testId} />;
		}

		case SessionViews.SCANS: {
			return showScansTab ? <MobileSdkTestScans testId={testId} /> : null;
		}

		case SessionViews.ALL_ISSUES: {
			return <MobileSdkTestAllIssues testId={testId} />;
		}

		default:
			return null;
	}
};
